
import * as React from 'react';

const Footer = () =>{

	return(
<>
{/* <section className="cta-banner-section fix section-padding pt-0" style={{background: "#c3daea"}}>
        <div className="container">
			
            <div className="cta-banner-wrapper section-padding bg-cover"
                >
				<div className="cta-content text-center">
					<h5>START EXPLORING</h5>
                    <h2 className="mb-10 wow fadeInUp" data-wow-delay=".3s">THE HOME STORE</h2>
						<p>10-20% DISCOUNTS ON ALL PRODUCTS</p><br/>
                    <a href="#" className="theme-btn wow fadeInUp" data-wow-delay=".5s"
                        style={{visibility: "visible", animationDelay: "0.5s", animation : "fadeInUp"}}>coming soon <i
                            className="fa-solid fa-arrow-right-long"></i></a>
                </div>
                <div className="book-shape">
                    <img src="/assets/img/book-shape.png" alt="shape-img"/>
                </div>
                                
            </div>
        </div>
    </section> */}

   
    <footer className="footer-section footer-bg">
      
        <div className="footer-widgets-wrapper">
            
            <div className="container">
                <div className="row">
                   
                    <div className="col-xl-4 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp" data-wow-delay=".4s">
						<div className="row">
							<div className="col-md-5">
								<div className="single-footer-widget">
									<div className="widget-head">
										<h3>MeriPustak</h3>
									</div>
									<ul className="list-area">
										<li><a href="/AboutUs">About Us</a></li>
										<li><a href="/Why-Us">Why Us</a></li>
									   <li><a href="/shippingoption">Shipping Options</a></li>
										{/* <li><a href="#">Blog</a></li> */}
										<li><a href="/contactus">Contact Us</a></li>
										<li><a href="/bulkorder">Bulk Order</a></li>
										<li><a href="/feedback">Feedback</a></li>
										<li><a href="/CounterfeitPolicy">ISO/IEC 27001:2022</a></li>
									</ul>
								</div>
							</div>
							<div className="col-md-7">
								<div className="single-footer-widget">
									<div className="widget-head">
										<h3>Help</h3>
									</div>
									<ul className="list-area">
										<li><a href="/returnpolicy">Return & Cancellation Policy</a></li>
										 <li><a href="/disclaimer">Disclaimer</a></li>
										 <li><a href="/privacypolicies">Privacy Policy</a></li>
										 <li><a href="/drugpolicy">Hygiene and Drug Policy</a></li>
										 <li><a href="/faq">Help / FAQ</a></li>
										 <li><a href="/TermsOfUse">Terms of Use</a></li>
										 <li><a href="/CounterfeitPolicy">COUNTERFEIT POLICY</a></li>
										
									</ul>
								</div>
							</div>
						</div>
                        
                    </div>
                  
					<div className="col-xl-5 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp" data-wow-delay=".4s">
                       <div className="row">
							<div className="col-md-6">
								<div className="single-footer-widget">
									<div className="widget-head">
										<h3>Contact</h3>
									</div>
									<ul className="list-area">
										<li><a href="/customer-support">Customer Support</a></li>
										<li><a href="/requestbook">Request a Book</a></li>
										<li><a href="mailto:contactus@meripustak.com"><i className="icon-icon-6"></i> contactus@meripustak.com</a></li>
										<li><a href="tel:18008917183">Toll Free   1800 891 7183</a></li>
										 <li><a href="tel:1148405001"> <i className="icon-icon-5"></i> +91-11-4840 5001</a></li>
										<li><a>WhatsApp only</a></li>
										<li><a href="https://wa.me/919990533212" target='_blan'><i className="fab fa-whatsapp"></i> + 91 99905 33212</a></li>

										{/* <a href="https://wa.me/918373968037">+91 8373968037</a> */}

										<li><a href="#">Mon-Sat 10:00 AM-06:00 PM IST</a></li>
									</ul>
									<img src="/assets/img/Make-In-IndiaLogo.png" alt="shape-img" width="200px"/>
								</div>
							</div>
							<div className="col-md-6">
								 <div className="single-footer-widget">
									<div className="widget-head">
										<h3>Payment Methods</h3>
									</div>
									<ul className="list-area">
										<li><a href="#">100% Secure Payments</a></li>
										<li><a href="/payment-method">Net Banking - All Major Indian Banks</a></li>
										<li><a href="/Ecash">By Digital Payment : Get 1% eCash</a></li>
									</ul>
									<img src="/assets/img/payments.png" alt="shape-img"/>
									<img src="/assets/img/world-delivery.png" alt="shape-img" width="180px" style={{marginLeft:"15px", marginTop:"15px"}} />
								</div>
							</div>
					   </div>
                    </div>
					<div className="col-xl-3 col-lg-4 col-md-6 ps-lg-5 wow fadeInUp" data-wow-delay=".4s">
                        <div className="single-footer-widget">
                            <div className="widget-head hf">
                                <h3>Follow Us</h3>
                            </div>
                            <div className="footer-content fc">
                               
                                <div className="social-icon d-flex align-items-center">
                                    <a href="https://www.facebook.com/meripustak"><i className="fab fa-facebook-f"></i></a>
                                    <a href="https://www.linkedin.com/company/meripustak-online-book-store/"><i className="fab fa-linkedin-in"></i></a>
                                </div>
								 <p>
                                    A Unit of Machwan Tech Services Private Limited
                                </p>
								<img src="/assets/img/SSL-Secure.png" alt="Meripustak" title="Meripustak SSL Secure" width="100px"/>
								<img src="/assets/img/iso-27001-2013-certification.png" alt="Meripustak" title="Meripustak SSL Secure" width="100px"/>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <div className="container">
                <div className="footer-wrapper  align-items-center">
                    <p className="wow fadeInLeft" data-wow-delay=".3s">
                        Copyright © 2025 www.meripustak.com. All rights reserved.


                    </p>
                    
                </div>
            </div>
        </div>
    </footer>

    

</>)
}
export default Footer;